import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Beaker, Zap, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

// Sloopladder trap 1 (2026-08-29): de Energy Flow Simulator is uit de navigatie
// gehaald. De KPI's daar (co2Saved, costSaved) waren animatie-tellers die elke
// 100 ms optelden zonder tijdbasis — geen berekening — en er staan nul scenes in
// de database. De route /crm/sandbox/energy-flow en alle bestanden blijven
// bestaan; terugzetten is deze regel terugdraaien.
const experiments: {
  id: string;
  title: string;
  description: string;
  icon: typeof Zap;
  href: string;
  status: 'active' | 'wip';
}[] = [];

const CRMSandbox = () => {
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Beaker className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Sandbox</h1>
          <p className="text-muted-foreground">Demo tools en experimenten voor super admins</p>
        </div>
        <Badge variant="outline" className="ml-auto">Super Admin Only</Badge>
      </div>

      {experiments.length === 0 && (
        <Card className="border-dashed">
          <CardContent className="py-12 text-center">
            <Beaker className="h-10 w-10 mx-auto mb-3 text-muted-foreground opacity-40" />
            <p className="text-muted-foreground">Geen actieve experimenten.</p>
          </CardContent>
        </Card>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {experiments.map((experiment) => (
          <Link key={experiment.id} to={experiment.href}>
            <Card className="h-full hover:border-primary/50 hover:shadow-md transition-all cursor-pointer group">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div className="p-2 rounded-lg bg-primary/10">
                    <experiment.icon className="h-5 w-5 text-primary" />
                  </div>
                  <Badge variant={experiment.status === 'active' ? 'default' : 'secondary'}>
                    {experiment.status === 'active' ? 'Actief' : 'In ontwikkeling'}
                  </Badge>
                </div>
                <CardTitle className="text-lg flex items-center gap-2">
                  {experiment.title}
                  <ArrowRight className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </CardTitle>
                <CardDescription>{experiment.description}</CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CRMSandbox;
